
import { defineComponent, inject, PropType, toRefs, computed } from "vue";
import { HouseTreeNode } from "./HouseTree.vue";

export default defineComponent({
  name: "HouseTreeNode",
  props: {
    node: {
      type: Object as PropType<HouseTreeNode>,
      required: true
    }
  },
  setup(props) {
    const { node } = toRefs(props);
    const multiple = inject<boolean>("multiple");

    // 使用扩展
    const userExpandedKeys = inject<string[]>("expandedKeys");
    const updateExpandedKeys = inject<(keys: string) => void>("updateExpandedKeys");
    // 使用已选择的
    const userChecked = inject<HouseTreeNode>("checked");

    const userCheckedList = inject<HouseTreeNode[]>("checkedList", []);

    const updateChecked = inject<(node: HouseTreeNode) => void>("updateChecked");
    const onclick = () => {
      if (node.value.is_house == "1") updateChecked?.(node.value);
    };

    const moreClick = () => {
      updateExpandedKeys?.(node.value.ppath);
    };

    const isChecked = computed(() => {
      if (multiple) {
        return userCheckedList.some(item => item === node.value);
      }
      return userChecked?.id === node.value.id;
    });

    const hasMore = computed(() => {
      return userExpandedKeys?.some(item => item === node.value.ppath);
    });

    return {
      userChecked,
      userCheckedList,
      userExpandedKeys,
      onclick,
      moreClick,
      multiple,
      isChecked,
      hasMore
    };
  }
});
